import React from 'react';
import {
  ContactUsLightTheme,
  ContactUsDarkTheme,
} from './variants/ContactUsVariantHelper';
import { ContactUsPageTypes } from './ContactUsPageTypes';
import { VariantContext } from './hooks/VariantContext';
import { Container } from '@codeparva/ui-components-library';

export const ContactUsPage = (props: ContactUsPageTypes.IContactUsPage) => {
  const variant = props.variant;

  const switchVariant = () => {
    switch (variant) {
      case 'newContactUsLightTheme':
        return <ContactUsLightTheme {...props} />;
      default:
        return <ContactUsDarkTheme {...props} />;
    }
  };

  return (
    <VariantContext.Provider value={variant}>
      <Container className="pt-3 mt-0">{switchVariant()}</Container>
    </VariantContext.Provider>
  );
};
